import { BottomSheetScrollView } from "@gorhom/bottom-sheet";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FlatList, StyleSheet, Text, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import BottomSheet from 'src/components/bottom-sheet';
import { getApp } from "../../../../../actions/app";
import FabBackButton from "../../../../../components/fab-back-button/FabBackButton.componet";
import PrimaryButton from "../../../../../components/primary-button/PrimaryButton.component";
import { CustomText } from "../../../../../components/text/Text";
import { isWeb } from "../../../../../constants";
import { selectrootsheettype } from "../../../../../selectors/SheetSelector";
import { colorPalette, textStyles } from "../../../../../theme";
import FeedbackItem from "../feedback-item/FeedBackItem";
import { showSheet } from "../../../../../actions/SheetActions";

const WrappperList=({ children })=>{
    if ( isWeb ){
      return children
    }else {
      return (
        <BottomSheetScrollView>
          {children}
        </BottomSheetScrollView>
      )
    }
  }


const ConfirmReturnDeposit = () => {
    const bottomSheetRef = useRef();
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { sheetId } = useSelector(state => selectrootsheettype(state));
    // const { supportBottomSheet } = useSelector((state)=>state.app.supportBottomSheet)

    const closeBottomSheet = () => {
        if (!isWeb) {
            bottomSheetRef.current?.close();
            setTimeout(() => {
                dispatch(
                    showSheet({
                        sheetId: '',
                    }),
                );
            }, 500);
        } else {
            bottomSheetRef?.current?.snapTo(() => 0);
        }
    };
    

    return <BottomSheet
        ref={bottomSheetRef}
        isScrollView={isWeb ? undefined : false}
        onClose={closeBottomSheet}
        blocking={isWeb ? true : undefined}
        scrollLocking={isWeb ? false : undefined}
        enablePanDownToClose={isWeb ? undefined :false}
        expandOnContentDrag={isWeb ? false :  undefined}
        onSpringEnd={
            isWeb
                ? () => {
                    if (bottomSheetRef?.current?.height < 2) {
                        dispatch(
                            showSheet({
                                sheetId: '',
                            }),
                        );
                    }
                }
                : undefined
        }
        snapPoints={isWeb ? ({ }) => [1, 685] : [685]}
        defaultSnap={isWeb ? 685 : undefined}
        open={sheetId == 'confirmReturnDeposit'}>
        <View style={styles.header}>
            <Text style={styles.screenTitle}>{t('confirm_return_deposit_request')}</Text>
            <FabBackButton
                container_style={styles.backButton}
                onPress={closeBottomSheet}
                icon={"closeIcon"}
            />
        </View>
        <View style={styles.container}>
            <CustomText mt={0} mb={12} size={13} font={'400'}>
                {t('share_the_cause_of_this_decision')}
            </CustomText>
            <View style={styles.listContainer}>
            <WrappperList>
            <FlatList
                showsVerticalScrollIndicator={false}
                data={['','','','','','' ,'','']}
                renderItem={() => <FeedbackItem />}
            />
            </WrappperList>
            </View>
            <View style={styles.btnsContainer}>
            <PrimaryButton title={t('request_registration')} containerStyle={styles.saveBtn}/>
            <PrimaryButton title={t('cancel')} textStyle={styles.cancleTextBtn} containerStyle={styles.cancelBtn}/>
            </View>
        </View>
    </BottomSheet>
}

export default ConfirmReturnDeposit

const styles = StyleSheet.create({
    cancleTextBtn : {
        color : '#000'
    },
    saveBtn : {
        width : '100%' ,
        height : 40 , 
    }, 
    cancelBtn : {
        backgroundColor  :'#fff' , 
        borderWidth : 1 , 
        borderColor : '#CFCFCF' ,
        marginTop : 12 , 
        width : '100%' ,
        height : 40 , 
    },
    listContainer : {
        // height : 500 , 
        flex : 1 , 
    } ,
    btnsContainer : {
        width : '100%' , 
        height : 44+  80 , 
        paddingTop : 12 , 
         
    },  
    header: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        alignSelf: 'flex-end',
    },
    container: {
        width: '100%',
        alignItems: 'flex-end',
        height : 600 , 
        flex: 1,
        paddingHorizontal: 16,
    },
    screenTitle: {
        fontFamily: textStyles.regular,
        fontSize: 18,
        color: colorPalette.grey8_5,
        marginRight: 8,
    },
    backButton: {
        marginVertical: 16,
        marginRight: 20,
        alignSelf: 'flex-end',
    },
})